import { compose } from 'recompose'
import syncApplications from './applications'

export providesApplicationsSubscriptions from './subscriptions'

export default compose(syncApplications())(function({ children }) {
  return children
})
